import { render, staticRenderFns } from "./MomentSoldOSListComponent.vue?vue&type=template&id=424b32fb&scoped=true&"
import script from "./MomentSoldOSListComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentSoldOSListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentSoldOSListComponent.vue?vue&type=style&index=0&id=424b32fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b32fb",
  null
  
)

export default component.exports